import { Component, Input, Output, EventEmitter } from '@angular/core';

export type AlertType = 'success' | 'warning' | 'error' | 'info';

@Component({
  selector: 'acs-alert',
  templateUrl: './acs-alert.html',
  styleUrls: ['./acs-alert.scss']
})
export class AcsAlertComponent {
  @Input() type: AlertType = 'info';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() dismissible: boolean = false;
  @Input() showIcon: boolean = true;
  @Input() actions: Array<{ label: string; action: () => void; variant?: 'primary' | 'secondary' | 'text' }> = [];

  @Output() dismissed = new EventEmitter<void>();

  get iconClass(): string {
    switch (this.type) {
      case 'success': return '✓';
      case 'warning': return '⚠';
      case 'error': return '✕';
      case 'info': return 'ℹ';
      default: return 'ℹ';
    }
  }

  get alertClasses(): string {
    return `acs-alert acs-alert--${this.type}`;
  }

  dismiss(): void {
    this.dismissed.emit();
  }

  onActionClick(action: () => void): void {
    action();
  }
}
